import leonsbuLogo from './img/leonsbuLogo.png';
import 'animate.css'
import './styles/App.css';
import { BackButton } from './components/BackButton';
import { FAN_ARTIST_USERNAMES } from './CONSTANTS'

export function Credits () {

    return (
      <div className='App'>
        <img src={leonsbuLogo} className='leonsbu-logo' alt='leonsbu logo' />
            <div className='infobox-1-outer about-box'>
              <div className='back-button-container'>
                <BackButton></BackButton>
              </div>
              <h1>Fan Art Credits</h1>
              {FAN_ARTIST_USERNAMES.map(username => {
                return <l className='fan-artist-credit'>{username}</l>
              })}
              <p>Discord "Hi!" Emoji by maasamoo</p>
              <h4>This website was fully written by LeonSBU. No AI was used in the creation of this site.</h4>
            </div>
      </div>
    )
}